module.exports = __webpack_public_path__ + "static/media/cwoc.722fe184.png";